import ColumnsTheme from './columns.theme';

export default ColumnsTheme;
